$(function () {
    /*==================================================
    検索 991px以下 でモーダルウィンドウfade表示/非表示
    ==================================================*/
    if ($('.modal-search').length) {
        $('.search-btn').on('click', function () {
            $('.modal-search').fadeIn(500);
            $('body').addClass('overflow');
            $('body').append('<div class="overlay-search"></div>');
        });
        $('#closeBtn').on('click', function () {
            $('body').removeClass('overflow');
            $('.overlay-search').fadeOut(300, function () {
                $('.overlay-search').remove();
            });
            $('.modal-search').fadeOut(300);
        });
        $('body').on('click', '.overlay-search', function (e) {
            $('body').removeClass('overflow');
            $('.modal-search').fadeOut(300);
            $(this).fadeOut(300, function () {
                $(this).remove();
            });
            e.stopPropagation();
        });
        $(window).on('load resize', function () {
            var wid = window.innerWidth;

            if (wid > 992) { // breakpoint設定する
                $('body').removeClass('overflow');
                $('.overlay-search').remove();
                $('.modal-search').fadeOut(0);
            }
        });
    };
    /*==================================================
    #が含まれたリンククリック時 headerの高さ分だけ戻る
    ==================================================*/
    $(window).on('load', function() {
        // ページのURLを取得
        const url = $(location).attr('href'),
        // headerの高さを取得してそれに30px追加した値をheaderHeightに代入
        headerHeight = $('header').outerHeight() + 30;

        // urlに「#」が含まれていれば
        if(url.indexOf("#") != -1){
            // urlを#で分割して配列に格納
            const anchor = url.split("#"),
            // 分割した最後の文字列（#◯◯の部分）をtargetに代入
            target = $('#' + anchor[anchor.length - 1]),
            // リンク先の位置からheaderHeightの高さを引いた値をpositionに代入
            position = Math.floor(target.offset().top) - headerHeight;
            // positionの位置に移動
            $("html, body").animate({scrollTop:position}, 500);
        }
    });
});
